import { useMutation } from 'react-query';
import { ReportMymeData } from '@myme/api';
import { reportMyme } from '@myme/logic';
import { useTranslation } from 'src/hooks';
import { toast, ToastType } from 'src/utils';

export const useReportMymeMutation = (clearForm: () => void) => {
  const { t } = useTranslation();

  const reportReviewMutation = useMutation(async (data: ReportMymeData) => reportMyme(data), {
    onSuccess: () => {
      toast(ToastType.SUCCESS, t('pages.mymes.details.report_myme_dialog.toast_success'));
      clearForm();
    }
  });

  return reportReviewMutation;
};
